"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.object.define-properties");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.split");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClient = getClient;
exports._getClientWithCookies = _getClientWithCookies;
exports.setLinkProvider = setLinkProvider;
exports.setCacheProvider = setCacheProvider;
exports.setSSRModeFlagProvider = setSSRModeFlagProvider;
exports.setGqlServer = setGqlServer;
exports.addLinkWrapper = addLinkWrapper;
exports.addGqlRoute = addGqlRoute;
exports.addGqlRouteLink = addGqlRouteLink;
exports.setLinkHeader = setLinkHeader;

var _client = require("@apollo/client");

var _context = require("@apollo/client/link/context");

var _isomorphicUnfetch = _interopRequireDefault(require("isomorphic-unfetch"));

var _configPlugin = require("@chegg-web-tools/config-plugin");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var $client;
var $getLink = defaultGetLink;
var $getCache = defaultGetCache; // since `ssrMode` is optional argument, default value for it would be `undefined`

var $getSSRModeFlag = function $getSSRModeFlag() {
  return undefined;
};

var GQL_SERVER = (0, _configPlugin.getConfig)('gqlServer');
var linkWrappers = [];
var headers = {};
var altLinks = {};
var altRoutes = [];

function getClient() {
  // For SSR we MUST create a new client on every request to avoid memory leaks
  if (!$client || $getSSRModeFlag()) {
    $client = initClient();
  }

  return $client;
}

function setGqlServer(url) {
  GQL_SERVER = url;
}

function addLinkWrapper(wrapper) {
  linkWrappers.unshift(wrapper);

  if ($client) {
    $client = getClient();
  }
}

function setLinkProvider(provider) {
  $getLink = provider;
}

function setLinkHeader(name, value) {
  headers[name] = value;
}

function setCacheProvider(provider) {
  $getCache = provider;
}

function setSSRModeFlagProvider(provider) {
  $getSSRModeFlag = provider;
}

function addGqlRoute(contextName, url) {
  altLinks[contextName] = new _client.HttpLink({
    uri: url,
    credentials: 'include',
    fetchOptions: {
      credentials: 'include'
    }
  });
  altRoutes.push(contextName);
}

function addGqlRouteLink(contextName, link) {
  altLinks[contextName] = link;
  altRoutes.push(contextName);
}

function _getClientWithCookies() {
  var cookies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  setLinkHeader('Cookie', cookies);
  $client = initClient();
  return $client;
}

function initClient() {
  var authToken = (0, _configPlugin.getConfig)('authToken');

  if (authToken) {
    setLinkHeader('Authorization', "Basic ".concat(authToken));
    setLinkHeader('Accept', 'application/json');
  }

  return new _client.ApolloClient({
    link: applyWrappers($getLink()),
    cache: $getCache(),
    ssrMode: $getSSRModeFlag()
  });
} //manage alt gql routes


addLinkWrapper(function (link) {
  var chosenRoute = '';
  var gqlRoutesLink = new _client.ApolloLink(function (op) {
    var link = altLinks[chosenRoute];
    chosenRoute = '';
    return link.request(op);
  });
  return _client.ApolloLink.split(function (op) {
    var context = op.getContext();

    for (var i = 0; i < altRoutes.length; i++) {
      if (context[altRoutes[i]]) {
        chosenRoute = altRoutes[i];
        return true;
      }
    }

    return false;
  }, gqlRoutesLink, link);
}); //inject headers into request

addLinkWrapper(function (link) {
  return _client.ApolloLink.concat((0, _context.setContext)(function (_, _ref) {
    var headers = _ref.headers;
    return {
      headers: _objectSpread(_objectSpread({}, headers), headers)
    };
  }), link);
});

function defaultGetLink() {
  return new _client.HttpLink({
    uri: GQL_SERVER,
    credentials: 'include',
    fetchOptions: {
      credentials: 'include'
    },
    fetch: _isomorphicUnfetch["default"]
  });
}

function defaultGetCache() {
  return new _client.InMemoryCache();
}

function applyWrappers(link) {
  return linkWrappers.reduce(function (link, wrapper) {
    return wrapper(link);
  }, link);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-web-tools/apollo-utils/dist/index.js
// module id = 242
// module chunks = 11